import {
  Box,
  Collapse,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import {
  NavLink,
  useMatch,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  AdminIcon,
  Logo,
  ParticipantIcon,
  QueryIcon,
  DashboardIcon,
  SmallLogo,
  StudySettingsIcon,
  TrackingIcon,
  // AddonsIcon,
  AppointmentsIcon,
  // MessagesIcon,
  AppointmentsIconActive,
  ParticipantIconActive,
  AdminIconActive,
  // AddonsIconActive,
  TrackingIconActive,
  StudySettingsIconActive,
  // MessagesIconActive,
  DashboardIconActive,
  QueryIconActive,
  AllStudiesIcon,
  AllStudiesIconActive,
  ConsentIconActive,
  ConsentIcon,
} from "../Common/assets/Sidebar";
import { Circle, ExpandLess, ExpandMore } from "@mui/icons-material";
import { useAppSelector } from "../../Redux/hooks";
import { useMemo, useState } from "react";
import { permissions } from "../../utils/roles";
// import VersionWrapper from "../Common/UI/VersionWrapper";
import { featuresMap } from "../../utils/features";
import {
  customSidebarStyle,
  customStepperStyle,
} from "../Common/styles/stepper";
import SidebarToggle from "./SidebarToggle";
// import UserProfileCard from "./UserProfileCard";
import VersionWrapper from "../Common/UI/VersionWrapper";

const StudySidebar = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const collapsed = useAppSelector((state) => state.app.collapsed);
  const [searchParams] = useSearchParams();
  const roleMatrixType = searchParams.get("type");
  const features = useAppSelector((state) => state.study.features);
  const status = useAppSelector((state) => state.study.status);
  const studyPermissions = useAppSelector(
    (state) => state.study.studyPermissions
  );

  const matchFunctions: {
    [key: string]: boolean;
  } = {
    users: !!useMatch("/studies/:id/users"),
    userDetails: !!useMatch("/studies/:id/users/:userId"),
    siteRights:
      !!useMatch("/studies/:id/permissions") && roleMatrixType === "site",
    studyRights:
      !!useMatch("/studies/:id/permissions") && roleMatrixType === "study",
    formPermissions: !!useMatch("studies/:id/form-permissions"),

    participantsList: !!useMatch("/studies/:id/participants/*"),
    participantGroups: !!useMatch("/studies/:id/participant-groups/*"),

    studySettings: !!useMatch("/studies/:id/study-settings"),
    studyTheme: !!useMatch("/studies/:id/study-theme"),

    auditLogs: !!useMatch("/studies/:id/audit-trail/*"),
    export: !!useMatch("/studies/:id/export/*"),

    medication: !!useMatch("/studies/:id/medication/*"),
    eConsent: !!useMatch("/studies/:id/e-consent/*"),
    myAppointments: !!useMatch("/studies/:id/appointments"),
    // myAvailability: !!useMatch("/studies/:id/my-availability/*"),
    messages: !!useMatch("/studies/:id/messages/*"),
    dashboard: !!useMatch("/studies/:id/dashboard/*"),
    studyDesigner: !!useMatch("/studies/:id/study-designer/*"),
    queries: !!useMatch("/studies/:id/queries/*"),
    eConsentsTracking: !!useMatch("/studies/:id/tracker/*"),
    exercise: !!useMatch("/studies/:id/exercise/*"),
    cms: !!useMatch("/studies/:id/cms/*"),
  };

  const rbac = useMemo(() => {
    return {
      participants: studyPermissions.includes(permissions.viewParticipant),
      queries: studyPermissions.includes(permissions.viewParticipant),
      usersManagement: studyPermissions.includes(permissions.userManagement),
      auditTrail: studyPermissions.includes(permissions.auditLogs),
      studySettings: studyPermissions.includes(permissions.studySettings),
      export: studyPermissions.includes(permissions.export),
      viewAppointment: studyPermissions.includes(permissions.viewAppointment),
      manageAppointment: studyPermissions.includes(
        permissions.manageAppointment
      ),
      studyDesigner: studyPermissions.includes(permissions.studyDesigner),
    };
  }, [studyPermissions]);

  const [userMgmtToggle, setUserMgmtToggle] = useState(false);
  // const [settingsToggle, setSettingsToggle] = useState(false);
  const [participantToggle, setParticipantToggle] = useState(false);
  const [trackingToggle, setTrackingToggle] = useState(false);
  const [, setAddOnsToggle] = useState(false);
  // const [appointmentsToggle, setAppointmentsToggle] = useState(false);

  const patientsNavLinks = [
    {
      label: "Participants",
      matchKey: "participantsList",
      link: `/studies/${id}/participants`,
    },
    {
      label: "User Groups",
      matchKey: "participantGroups",
      link: `/studies/${id}/participant-groups`,
    },
  ];

  // const appointmentNavLinks = [
  //   {
  //     label: "My Appointments",
  //     matchKey: "myAppointments",
  //     link: `/studies/${id}/my-appointments`,
  //     enabled: rbac.manageAppointment,
  //   },
  //   {
  //     label: "Team Calendar",
  //     matchKey: "teamCalendar",
  //     link: `/studies/${id}/team-calendar`,
  //     enabled: rbac.viewAppointment,
  //   },
  //   // {
  //   //   label: "My Availability",
  //   //   matchKey: "myAvailability",
  //   //   link: `/studies/${id}/my-availability`,
  //   // },
  // ].filter((step) => step.enabled);

  const userMgmtNavLinks = [
    {
      label: "Users",
      matchKey: "users",
      link: `/studies/${id}/users`,
    },
    {
      label: "Site Rights",
      matchKey: "siteRights",
      link: `/studies/${id}/permissions?type=site`,
    },
    {
      label: "Study Rights",
      matchKey: "studyRights",
      link: `/studies/${id}/permissions?type=study`,
    },
    {
      label: "Form Permissions",
      matchKey: "formPermissions",
      link: `/studies/${id}/form-permissions`,
    },
  ];
  // const addonsNavLinks = [
  //   {
  //     label: "Content",
  //     matchKey: "cms",
  //     link: `/studies/${id}/cms`,
  //     enabled: features?.[featuresMap.cms],
  //   },
  //   {
  //     label: "Exercises",
  //     matchKey: "exercise",
  //     link: `/studies/${id}/exercise`,
  //     enabled: features?.[featuresMap.exercises],
  //   },
  //   {
  //     label: "Medication",
  //     matchKey: "medication",
  //     link: `/studies/${id}/medication`,
  //     enabled: features?.[featuresMap.medication],
  //   },
  // ].filter((step) => step.enabled);

  const trackingNavLinks = [
    {
      label: "Tracker",
      matchKey: "eConsentsTracking",
      link: `/studies/${id}/tracker`,
      enabled: features?.[featuresMap.eConsent] && rbac.participants,
    },
    {
      label: "Audit Trail",
      matchKey: "auditLogs",
      link: `/studies/${id}/audit-trail`,
      enabled: rbac.auditTrail,
    },
    {
      label: "Export",
      matchKey: "export",
      link: `/studies/${id}/export`,
      enabled: rbac.export,
    },
  ].filter((step) => step.enabled);

  // const settingsNavLinks = [
  //   {
  //     label: "Study Settings",
  //     matchKey: "studySettings",
  //     link: `/studies/${id}/study-settings`,
  //   },
  //   {
  //     label: "Study Theme",
  //     matchKey: "studyTheme",
  //     link: `/studies/${id}/study-theme`,
  //   },
  // ];

  function userManageMentToggle() {
    if (collapsed) {
      navigate(`/studies/${id}/users`);
      setUserMgmtToggle(true);
      // setAppointmentsToggle(false);
      setTrackingToggle(false);
      // setSettingsToggle(false);
      setAddOnsToggle(false);
      setParticipantToggle(false);
    } else {
      navigate(`/studies/${id}/users`);
      setUserMgmtToggle((prev) => {
        const newState = !prev;
        if (newState) {
          // setAppointmentsToggle(false);
          setTrackingToggle(false);
          // setSettingsToggle(false);
          setAddOnsToggle(false);
          setParticipantToggle(false);
        }
        return newState;
      });
    }
  }

  function participantsToggle() {
    if (collapsed) {
      navigate(`/studies/${id}/participants`);
      setParticipantToggle(true);
      // setAppointmentsToggle(false);
      setTrackingToggle(false);
      setAddOnsToggle(false);
      setUserMgmtToggle(false);
      // setSettingsToggle(false);
    } else {
      navigate(`/studies/${id}/participants`);
      setParticipantToggle((prev) => {
        const newState = !prev;
        if (newState) {
          // setAppointmentsToggle(false);
          setTrackingToggle(false);
          setAddOnsToggle(false);
          setUserMgmtToggle(false);
          // setSettingsToggle(false);
        }
        return newState;
      });
    }
  }

  // function studySettingsToggle() {
  //   if (collapsed) {
  //     navigate(`/studies/${id}/study-settings`);
  //     setSettingsToggle(true);
  //     setUserMgmtToggle(false);
  //     setAppointmentsToggle(false);
  //     setTrackingToggle(false);
  //     setAddOnsToggle(false);
  //     setParticipantToggle(false);
  //   } else {
  //     setSettingsToggle((prev) => {
  //       const newState = !prev;
  //       if (newState) {
  //         setUserMgmtToggle(false);
  //         setAppointmentsToggle(false);
  //         setTrackingToggle(false);
  //         setAddOnsToggle(false);
  //         setParticipantToggle(false);
  //       }
  //       return newState;
  //     });
  //   }
  // }

  function studyTrackingToggle() {
    if (collapsed) {
      if (features?.[featuresMap.eConsent] && rbac.participants) {
        navigate(`/studies/${id}/tracker`);
      } else if (rbac.auditTrail) {
        navigate(`/studies/${id}/audit-trail`);
      } else if (rbac.export) {
        navigate(`/studies/${id}/export`);
      }
      setTrackingToggle(true);
      setParticipantToggle(false);
      // setAppointmentsToggle(false);
      setAddOnsToggle(false);
      setUserMgmtToggle(false);
      // setSettingsToggle(false);
    } else {
      if (features?.[featuresMap.eConsent] && rbac.participants) {
        navigate(`/studies/${id}/tracker`);
      } else if (rbac.auditTrail) {
        navigate(`/studies/${id}/audit-trail`);
      } else if (rbac.export) {
        navigate(`/studies/${id}/export`);
      }
      setTrackingToggle((prev) => {
        const newState = !prev;
        if (newState) {
          setParticipantToggle(false);
          // setAppointmentsToggle(false);
          setAddOnsToggle(false);
          setUserMgmtToggle(false);
          // setSettingsToggle(false);
        }
        return newState;
      });
    }
  }

  // function studyAddOnsToggle() {
  //   if (collapsed) {
  //     if (features?.[featuresMap.cms]) {
  //       navigate(`/studies/${id}/cms`);
  //     } else if (features?.[featuresMap.exercises]) {
  //       navigate(`/studies/${id}/exercise`);
  //     } else if (features?.[featuresMap.medication]) {
  //       navigate(`/studies/${id}/medication`);
  //     }
  //     setAddOnsToggle(true);
  //     setUserMgmtToggle(false);
  //     setAppointmentsToggle(false);
  //     setTrackingToggle(false);
  //     // setSettingsToggle(false);
  //     setParticipantToggle(false);
  //   } else {
  //     if (features?.[featuresMap.cms]) {
  //       navigate(`/studies/${id}/cms`);
  //     } else if (features?.[featuresMap.exercises]) {
  //       navigate(`/studies/${id}/exercise`);
  //     } else if (features?.[featuresMap.medication]) {
  //       navigate(`/studies/${id}/medication`);
  //     }
  //     setAddOnsToggle((prev) => {
  //       const newState = !prev;
  //       if (newState) {
  //         setUserMgmtToggle(false);
  //         setAppointmentsToggle(false);
  //         setTrackingToggle(false);
  //         // setSettingsToggle(false);
  //         setParticipantToggle(false);
  //       }
  //       return newState;
  //     });
  //   }
  // }

  // function studyAppointmentsToggle() {
  //   if (collapsed) {
  //     navigate(`/studies/${id}/my-appointments`);
  //     setAppointmentsToggle(true);
  //     setParticipantToggle(false);
  //     setTrackingToggle(false);
  //     setUserMgmtToggle(false);
  //     // setSettingsToggle(false);
  //     setAddOnsToggle(false);
  //   } else {
  //     navigate(`/studies/${id}/my-appointments`);
  //     setAppointmentsToggle((prev) => {
  //       const newState = !prev;
  //       if (newState) {
  //         setParticipantToggle(false);
  //         setTrackingToggle(false);
  //         setUserMgmtToggle(false);
  //         // setSettingsToggle(false);
  //         setAddOnsToggle(false);
  //       }
  //       return newState;
  //     });
  //   }
  // }

  return (
    <Box
      className={`sidebar ${collapsed ? "collapsed" : ""}`}
      sx={{
        // "& .active.sider-menu": {
        //   backgroundColor: "primary.main",
        // },
        "& .user-management-menu": {
          color: "text.secondary",
        },
      }}
    >
      <SidebarToggle type="study" />
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: 2,
            marginBlock: "10px",
          }}
        >
          {!collapsed ? <Logo /> : <SmallLogo />}
        </Box>
        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #1F438A",
            borderRadius: "10px",
            height: "41px",
            p: 1,
            mb: 1.5,
            width: "100%",
          }}
        >
          <UserProfileCard collapsed={collapsed} />
        </Box> */}
        <NavLink
          to={`/studies/${id}/dashboard`}
          title="Dashboard"
          className={({ isActive }) =>
            isActive ? "sider-menu active" : "sider-menu"
          }
        >
          {matchFunctions.dashboard ? (
            <DashboardIconActive />
          ) : (
            <DashboardIcon />
          )}
          {!collapsed && (
            <Typography variant="body2" fontWeight="regular">
              Dashboard
            </Typography>
          )}
        </NavLink>
        {status === "not_live" && rbac.studyDesigner && (
          <NavLink
            title="Study Designer"
            to={`/studies/${id}/study-designer`}
            className={"sider-menu"}
          >
            {matchFunctions.studyDesigner ? (
              <AllStudiesIconActive />
            ) : (
              <AllStudiesIcon />
            )}

            {!collapsed && (
              <Typography variant="body2" fontWeight="regular">
                Study Designer
              </Typography>
            )}
          </NavLink>
        )}

        {!features?.[featuresMap.participantGroups] ? (
          <>
            {rbac.participants && (
              <NavLink
                title="Participants"
                to={`/studies/${id}/participants`}
                className={
                  matchFunctions.participantsList
                    ? "sider-menu active"
                    : "sider-menu"
                }
              >
                {matchFunctions.participantsList ? (
                  <ParticipantIconActive />
                ) : (
                  <ParticipantIcon />
                )}

                {!collapsed && (
                  <Typography variant="body2" fontWeight="regular">
                    Participants
                  </Typography>
                )}
              </NavLink>
            )}
          </>
        ) : (
          <>
            {rbac.participants && (
              <Box
                className={
                  matchFunctions.participantsList ||
                  matchFunctions.participantGroups
                    ? "sider-menu active"
                    : "sider-menu"
                }
                onClick={participantsToggle}
              >
                {matchFunctions.participantsList ||
                matchFunctions.participantGroups ? (
                  <ParticipantIconActive />
                ) : (
                  <ParticipantIcon />
                )}
                {!collapsed && (
                  <Box sx={customSidebarStyle}>
                    <Typography
                      overflow={"hidden"}
                      textOverflow={"ellipsis"}
                      whiteSpace={"nowrap"}
                      title="Participants"
                      variant="body2"
                      fontWeight="regular"
                    >
                      Participants
                    </Typography>
                    {!participantToggle ? <ExpandMore /> : <ExpandLess />}
                  </Box>
                )}
              </Box>
            )}
            {!collapsed && (
              <Collapse
                in={participantToggle && rbac.participants}
                timeout={"auto"}
                unmountOnExit
                sx={{ p: "8px 0px" }}
              >
                <Stepper orientation="vertical" sx={customStepperStyle}>
                  {patientsNavLinks.map((step, index) => (
                    <Step key={step.matchKey}>
                      <StepLabel
                        icon={
                          <Circle
                            sx={{
                              color: matchFunctions?.[step.matchKey]
                                ? "#FFFFFF"
                                : "text.secondary",
                              height: "10px",
                              width: "10px",
                            }}
                          />
                        }
                      >
                        <NavLink
                          title={step.label}
                          to={step.link}
                          className={({ isActive }) =>
                            isActive && matchFunctions?.[step.matchKey]
                              ? "user-management-menu active"
                              : "user-management-menu"
                          }
                        >
                          <Typography
                            variant="body2"
                            overflow={"hidden"}
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                          >
                            {step.label}
                          </Typography>
                        </NavLink>
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Collapse>
            )}
          </>
        )}

        {/* {features?.[featuresMap.appointment] &&
          appointmentNavLinks.length > 1 && (
            <>
              <Box
                className={
                  matchFunctions.myAppointments || matchFunctions.teamCalendar
                    ? "sider-menu active"
                    : "sider-menu"
                }
                onClick={studyAppointmentsToggle}
              >
                {matchFunctions.myAppointments ||
                matchFunctions.teamCalendar ? (
                  <AppointmentsIconActive />
                ) : (
                  <AppointmentsIcon />
                )}
                {!collapsed && (
                  <Box sx={customSidebarStyle}>
                    <Typography
                      overflow={"hidden"}
                      textOverflow={"ellipsis"}
                      whiteSpace={"nowrap"}
                      title="Appointments"
                      variant="body2"
                      fontWeight="regular"
                    >
                      Appointments
                    </Typography>
                    {!appointmentsToggle ? <ExpandMore /> : <ExpandLess />}
                  </Box>
                )}
              </Box>

              {!collapsed && (
                <Collapse
                  in={
                    appointmentsToggle &&
                    (rbac.viewAppointment || rbac.manageAppointment)
                  }
                  timeout={"auto"}
                  unmountOnExit
                  sx={{ p: "8px 0px" }}
                >
                  <Stepper orientation="vertical" sx={customStepperStyle}>
                    {appointmentNavLinks.map((step, index) => (
                      <Step key={step.matchKey}>
                        <StepLabel
                          icon={
                            <Circle
                              sx={{
                                color: matchFunctions?.[step.matchKey]
                                  ? "#FFFFFF"
                                  : "text.secondary",
                                height: "10px",
                                width: "10px",
                              }}
                            />
                          }
                        >
                          <NavLink
                            title={step.label}
                            to={step.link}
                            className={({ isActive }) =>
                              isActive && matchFunctions?.[step.matchKey]
                                ? "user-management-menu active"
                                : "user-management-menu"
                            }
                          >
                            <Typography
                              variant="body2"
                              overflow={"hidden"}
                              textOverflow={"ellipsis"}
                              whiteSpace={"nowrap"}
                            >
                              {step.label}
                            </Typography>
                          </NavLink>
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Collapse>
              )}
            </>
          )} */}

        {features?.[featuresMap.appointment] && (
          <NavLink
            to={`/studies/${id}/appointments`}
            title="Appointments"
            className={
              matchFunctions.myAppointments ? "sider-menu active" : "sider-menu"
            }
          >
            {matchFunctions.myAppointments ? (
              <AppointmentsIconActive />
            ) : (
              <AppointmentsIcon />
            )}
            {!collapsed && (
              <Typography
                variant="body2"
                fontWeight="regular"
                overflow={"hidden"}
                textOverflow={"ellipsis"}
                whiteSpace={"nowrap"}
                title="Appointments"
              >
                Appointments
              </Typography>
            )}
          </NavLink>
        )}

        {/* {features?.[featuresMap.messages] && (
          <NavLink
            to={`/studies/${id}/messages`}
            title="Messages"
            className={
              matchFunctions.messages ? "sider-menu active" : "sider-menu"
            }
          >
            {matchFunctions.messages ? (
              <MessagesIconActive />
            ) : (
              <MessagesIcon />
            )}
            {!collapsed && (
              <Typography
                variant="body2"
                fontWeight="regular"
                overflow={"hidden"}
                textOverflow={"ellipsis"}
                whiteSpace={"nowrap"}
                title="Messages"
              >
                Messages
              </Typography>
            )}
          </NavLink>
        )} */}

        {features?.[featuresMap.eConsent] && rbac.studyDesigner && (
          <NavLink
            to={`/studies/${id}/e-consent`}
            title="Consent"
            className={
              matchFunctions.eConsent ? "sider-menu active" : "sider-menu"
            }
          >
            {matchFunctions.eConsent ? <ConsentIconActive /> : <ConsentIcon />}
            {!collapsed && (
              <Typography
                variant="body2"
                fontWeight="regular"
                overflow={"hidden"}
                textOverflow={"ellipsis"}
                whiteSpace={"nowrap"}
                title="Consent"
              >
                Consent
              </Typography>
            )}
          </NavLink>
        )}

        {rbac.usersManagement && (
          <Box
            className={
              matchFunctions.siteRights ||
              matchFunctions.studyRights ||
              matchFunctions.users ||
              matchFunctions.userDetails ||
              matchFunctions.formPermissions
                ? "sider-menu active"
                : "sider-menu"
            }
            onClick={userManageMentToggle}
          >
            {matchFunctions.siteRights ||
            matchFunctions.studyRights ||
            matchFunctions.users ||
            matchFunctions.userDetails ||
            matchFunctions.formPermissions ? (
              <AdminIconActive />
            ) : (
              <AdminIcon />
            )}

            {!collapsed && (
              <Box sx={customSidebarStyle}>
                <Typography
                  overflow={"hidden"}
                  textOverflow={"ellipsis"}
                  whiteSpace={"nowrap"}
                  title="Administration"
                  variant="body2"
                  fontWeight="regular"
                >
                  Administration
                </Typography>
                {!userMgmtToggle ? <ExpandMore /> : <ExpandLess />}
              </Box>
            )}
          </Box>
        )}
        {!collapsed && (
          <Collapse
            in={userMgmtToggle && rbac.usersManagement}
            timeout={"auto"}
            unmountOnExit
            sx={{ p: "8px 0px" }}
          >
            <Stepper orientation="vertical" sx={customStepperStyle}>
              {userMgmtNavLinks.map((step, index) => (
                <Step key={step.matchKey}>
                  <StepLabel
                    icon={
                      <Circle
                        sx={{
                          color: matchFunctions?.[step.matchKey]
                            ? "#FFFFFF"
                            : "text.secondary",
                          height: "10px",
                          width: "10px",
                        }}
                      />
                    }
                  >
                    <NavLink
                      title={step.label}
                      to={step.link}
                      className={({ isActive }) =>
                        isActive && matchFunctions?.[step.matchKey]
                          ? "user-management-menu active"
                          : "user-management-menu"
                      }
                    >
                      <Typography
                        variant="body2"
                        overflow={"hidden"}
                        textOverflow={"ellipsis"}
                        whiteSpace={"nowrap"}
                      >
                        {step.label}
                      </Typography>
                    </NavLink>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Collapse>
        )}

        {/* {(features?.[featuresMap.cms] ||
          features?.[featuresMap.medication] ||
          features?.[featuresMap.exercises]) && (
          <Box
            className={
              matchFunctions.cms ||
              matchFunctions.medication ||
              matchFunctions.exercise
                ? "sider-menu active"
                : "sider-menu"
            }
            onClick={studyAddOnsToggle}
          >
            {matchFunctions.cms ||
            matchFunctions.medication ||
            matchFunctions.exercise ? (
              <AddonsIconActive />
            ) : (
              <AddonsIcon />
            )}

            {!collapsed && (
              <Box sx={customSidebarStyle}>
                <Typography
                  overflow={"hidden"}
                  textOverflow={"ellipsis"}
                  whiteSpace={"nowrap"}
                  title="Addons"
                  variant="body2"
                  fontWeight="regular"
                >
                  Addons
                </Typography>
                {!addOnsToggle ? <ExpandMore /> : <ExpandLess />}
              </Box>
            )}
          </Box>
        )}
        {!collapsed &&
          (features?.[featuresMap.cms] ||
            features?.[featuresMap.medication] ||
            features?.[featuresMap.exercises]) && (
            <Collapse
              in={addOnsToggle}
              timeout={"auto"}
              unmountOnExit
              sx={{ p: "8px 0px" }}
            >
              <Stepper orientation="vertical" sx={customStepperStyle}>
                {addonsNavLinks.map((step, index) => (
                  <Step key={step.matchKey}>
                    <StepLabel
                      icon={
                        <Circle
                          sx={{
                            color: matchFunctions?.[step.matchKey]
                              ? "#FFFFFF"
                              : "text.secondary",
                            height: "10px",
                            width: "10px",
                          }}
                        />
                      }
                    >
                      <NavLink
                        title={step.label}
                        to={step.link}
                        className={({ isActive }) =>
                          isActive && matchFunctions?.[step.matchKey]
                            ? "user-management-menu active"
                            : "user-management-menu"
                        }
                      >
                        <Typography
                          variant="body2"
                          overflow={"hidden"}
                          textOverflow={"ellipsis"}
                          whiteSpace={"nowrap"}
                        >
                          {step.label}
                        </Typography>
                      </NavLink>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Collapse>
          )} */}

        {trackingNavLinks.length > 0 && (
          <Box
            className={
              matchFunctions.auditLogs ||
              matchFunctions.export ||
              matchFunctions.eConsentsTracking
                ? "sider-menu active"
                : "sider-menu"
            }
            onClick={studyTrackingToggle}
          >
            {matchFunctions.auditLogs ||
            matchFunctions.export ||
            matchFunctions.eConsentsTracking ? (
              <TrackingIconActive />
            ) : (
              <TrackingIcon />
            )}

            {!collapsed && (
              <Box sx={customSidebarStyle}>
                <Typography
                  overflow={"hidden"}
                  textOverflow={"ellipsis"}
                  whiteSpace={"nowrap"}
                  title="Tracking"
                  variant="body2"
                  fontWeight="regular"
                >
                  Tracking
                </Typography>
                {!trackingToggle ? <ExpandMore /> : <ExpandLess />}
              </Box>
            )}
          </Box>
        )}
        {!collapsed && (
          <Collapse
            in={
              trackingToggle &&
              (rbac.auditTrail || rbac.export || rbac.participants)
            }
            timeout={"auto"}
            unmountOnExit
            sx={{ p: "8px 0px" }}
          >
            <Stepper orientation="vertical" sx={customStepperStyle}>
              {trackingNavLinks.map((step, index) => (
                <Step key={step.matchKey}>
                  <StepLabel
                    icon={
                      <Circle
                        sx={{
                          color: matchFunctions?.[step.matchKey]
                            ? "#FFFFFF"
                            : "text.secondary",
                          height: "10px",
                          width: "10px",
                        }}
                      />
                    }
                  >
                    <NavLink
                      title={step.label}
                      to={step.link}
                      className={({ isActive }) =>
                        isActive && matchFunctions?.[step.matchKey]
                          ? "user-management-menu active"
                          : "user-management-menu"
                      }
                    >
                      <Typography
                        variant="body2"
                        overflow={"hidden"}
                        textOverflow={"ellipsis"}
                        whiteSpace={"nowrap"}
                      >
                        {step.label}
                      </Typography>
                    </NavLink>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Collapse>
        )}

        {rbac.queries && features?.[featuresMap.queries] && (
          <NavLink
            to={`/studies/${id}/queries`}
            title="Queries"
            className={({ isActive }) =>
              isActive ? "sider-menu active" : "sider-menu"
            }
          >
            {matchFunctions.queries ? <QueryIconActive /> : <QueryIcon />}
            {!collapsed && (
              <Typography variant="body2" fontWeight="regular">
                Queries
              </Typography>
            )}
          </NavLink>
        )}

        {status !== "not_live" && (
          <NavLink
            title="Study Designer"
            to={`/studies/${id}/study-designer`}
            className={"sider-menu"}
          >
            {matchFunctions.studyDesigner ? (
              <AllStudiesIconActive />
            ) : (
              <AllStudiesIcon />
            )}
            {!collapsed && (
              <Typography variant="body2" fontWeight="regular">
                Study Designer
              </Typography>
            )}
          </NavLink>
        )}
        {/* {rbac.studySettings && (
          <Box
            className={
              matchFunctions.studySettings || matchFunctions.studyTheme
                ? "sider-menu active"
                : "sider-menu"
            }
            onClick={studySettingsToggle}
          >
            <StudySettingsIcon />
            {!collapsed && (
              <Box display={"flex"} maxWidth={"125px"}>
                <Typography
                  variant="body2" fontWeight="regular"
                  overflow={"hidden"}
                  textOverflow={"ellipsis"}
                  whiteSpace={"nowrap"}
                  title="Settings"
                >
                  Settings
                </Typography>
              </Box>
            )}
          </Box>
        )}
        {!collapsed && (
          <Collapse
            in={settingsToggle && rbac.studySettings}
            timeout={"auto"}
            unmountOnExit
            sx={{ p: "8px 24px" }}
          >
            <NavLink
              title="Study Settings"
              to={`/studies/${id}/study-settings`}
              className={({ isActive }) =>
                isActive
                  ? "user-management-menu active"
                  : "user-management-menu"
              }
            >
              {!collapsed && (
                <Typography
                  variant="body1"
                  overflow={"hidden"}
                  textOverflow={"ellipsis"}
                  whiteSpace={"nowrap"}
                >
                  Study Settings
                </Typography>
              )}
            </NavLink>
            <NavLink
              title="Study Theme"
              to={`/studies/${id}/study-theme`}
              className={({ isActive }) =>
                isActive
                  ? "user-management-menu active"
                  : "user-management-menu"
              }
            >
              {!collapsed && (
                <Typography
                  variant="body1"
                  overflow={"hidden"}
                  textOverflow={"ellipsis"}
                  whiteSpace={"nowrap"}
                >
                  Study Theme
                </Typography>
              )}
            </NavLink>
          </Collapse>
        )} */}
        {/* {rbac.studySettings && (
          <Box
            className={
              matchFunctions.studySettings || matchFunctions.studyTheme
                ? "sider-menu active"
                : "sider-menu"
            }
            onClick={studySettingsToggle}
          >
            {matchFunctions.studySettings || matchFunctions.studyTheme ? (
              <StudySettingsIconActive />
            ) : (
              <StudySettingsIcon />
            )}

            {!collapsed && (
              <Box sx={customSidebarStyle}>
                <Typography
                  overflow={"hidden"}
                  textOverflow={"ellipsis"}
                  whiteSpace={"nowrap"}
                  title="Settings"
                >
                  Settings
                </Typography>
                {!settingsToggle ? <ExpandMore /> : <ExpandLess />}
              </Box>
            )}
          </Box>
        )}
        {!collapsed && (
          <Collapse
            in={settingsToggle && rbac.studySettings}
            timeout={"auto"}
            unmountOnExit
            sx={{ p: "8px 24px" }}
          >
            <Stepper orientation="vertical" sx={customStepperStyle}>
              {settingsNavLinks.map((step, index) => (
                <Step key={step.matchKey}>
                  <StepLabel
                    icon={
                      <Circle
                        sx={{
                          color: matchFunctions?.[step.matchKey]
                            ? "#FFFFFF"
                            : "text.secondary",
                          height: "10px",
                          width: "10px",
                        }}
                      />
                    }
                  >
                    <NavLink
                      title={step.label}
                      to={step.link}
                      className={({ isActive }) =>
                        isActive && matchFunctions?.[step.matchKey]
                          ? "user-management-menu active"
                          : "user-management-menu"
                      }
                    >
                      <Typography
                        variant="body1"
                        overflow={"hidden"}
                        textOverflow={"ellipsis"}
                        whiteSpace={"nowrap"}
                      >
                        {step.label}
                      </Typography>
                    </NavLink>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Collapse>
        )} */}

        {rbac.studySettings && (
          <NavLink
            to={`/studies/${id}/study-settings`}
            title="Settings"
            className={({ isActive }) =>
              isActive ? "sider-menu active" : "sider-menu"
            }
          >
            {matchFunctions.studySettings ? (
              <StudySettingsIconActive />
            ) : (
              <StudySettingsIcon />
            )}
            {!collapsed && (
              <Typography variant="body2" fontWeight="regular">
                Settings
              </Typography>
            )}
          </NavLink>
        )}
      </Box>

      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IconButton onClick={toggleCollapse}>
          {collapsed ? (
            <ChevronRight fontSize="large" />
          ) : (
            <ChevronLeft fontSize="large" />
          )}
        </IconButton>
      </Box> */}
      <VersionWrapper />
    </Box>
  );
};

export default StudySidebar;
